/**
 * Created by mcochrane on 25/08/17.
 */
import { addScript, addScriptWithSrc, addCss, addCssWithSrc } from './helpers'
import Vue from 'vue'

export class CustomScript {
  /**
   * Constructor for CustomScript.  Loads a custom script.
   * @param name          the name of the script
   * @param data          the url where the script can be loaded from or
   *                      the actual javascript content of the script.
   * @param isUrl        true if the data parameter is a url
   *                      false if it's the raw script (js/css)
   * @param type          either 'js' or 'css'
   */
  constructor (name, data, isUrl = false, type = 'js') {
    this.script_name = name
    this.content = ''
    this.url = ''
    this.type = type.toLowerCase()
    this.domNode = null
    this.loaded = false
    if (isUrl) {
      this.url = data
      this.writeToDOM()
    } else {
      this.content = data
      this.writeToDOM()
    }
  }

  /**
   * Returns true if this script is loaded from a url and false if not.
   * @returns {boolean}
   */
  isUrl () {
    return this.url !== ''
  }

  isLoaded () {
    return this.loaded
  }

  _writeCssToDom () {
    if (this.isUrl()) {
      this.domNode = addCssWithSrc(this.url)
    } else {
      this.domNode = addCss(this.content)
    }
  }

  _writeJsToDom () {
    if (this.isUrl()) {
      this.domNode = addScriptWithSrc(this.url)
    } else {
      this.domNode = addScript(this.content)
    }
  }

  writeToDOM () {
    if (this.type === 'js') {
      this._writeJsToDom()
    } else if (this.type === 'css') {
      this._writeCssToDom()
    } else {
      throw new Error('Invalid CustomScript type :' + this.type)
    }

    let vthis = this
    Vue.nextTick(function () {
      vthis.loaded = true
    })
  }

  deleteFromDOM () {
    if (this.domNode !== null) {
      document.body.removeChild(this.domNode)
      this.domNode = null
      this.loaded = false
    }
  }
}
